export class QuotationResponse {
	balance: number;
	cancelled: boolean;
	client: number;
	company: number;
	creationDate: number;
	currency: number;
	deadline: number;
	description: string;
	discount: number;
	downloadable: boolean;
	exchangeRate: number;
	executed: boolean;
	hasAffiliate: boolean;
	id: number;
	invoice: boolean;
	name: string;
	nit: string;
	pointsAffiliate: number;
	totalCost: number;
	user: number;
	valorAffiliate: any
	warehouse: number;
}